import React from 'react';
import { ModalWindows } from './components/ModalWindows';
import Form from './components/Form/Form';
import CreateRestaurantState from './createRestaurantState/CreateRestaurantState';

const CreateRestaurantPage: React.FC = () => {
	return (
		<CreateRestaurantState>
			<Form />
			<ModalWindows />
		</CreateRestaurantState>
	);
};

export default CreateRestaurantPage;
